<div>
  <h4 class="title">
    CONSENT FORM TO RECEIVE ELECTRONIC DISCLOSURES AND COMMUNICATIONS
  </h4>
  <br />
  <p>
    <span
      ><img
        class="image"
        width="129"
        height="82"
        alt="image"
        src="../assets/img/Image_001.png"/></span
    ><br />
  </p>

  <p>
    IMPORTANT INFORMATION WILL BE FURNISHED TO YOU ELECTRONICALLY.
  </p>
  <p><br /></p>
  <ol>
    <li>
      <p>
        READ THIS NOTICE CAREFULLY AND KEEP A COPY FOR YOUR RECORDS.
      </p>
      <p><br /></p>
      <p>
        This Consent Form pertains to the delivery of Communications related to
        your Navy Cash&reg; account provided and issued by PNC Bank, National
        Association (“PNC”) in conjunction with the US Department of the
        Treasury, Bureau of the Fiscal Service (“Fiscal Service”).
      </p>
      <br />
      <p>
        Certain laws and regulations require PNC to deliver specific information
        to you “in writing”, which means delivery of the information on paper.
        With the passage of the E-Sign Act, and similar state statutes, we may
        provide such information to you electronically if we present you certain
        disclosures (as contained in this notice) and you agree (consent) to
        receive the information electronically. Your consent will also apply to
        any other person named on your account.
      </p>
      <br />
      <p>
        You have or may have the option to receive “Communications” (as defined
        below) electronically rather than on paper. So that we may fulfill this
        request, you agree that we may electronically provide to you disclosures
        and information related to your account, and you must have the ability
        to print or download the information. By consenting to receive
        information electronically, you will not receive the information in
        paper form, except when Communications are provided in paper form or as
        otherwise noted below.
      </p>
      <br />
      <p>
        Please read the following important information about electronic
        Communications before you decide to receive them electronically:
      </p>
      <br />
    </li>
    <li>
      <p>
        DISCLOSURES AND COMMUNICATIONS AVAILABLE ELECTRONICALLY
      </p>
      <br />
      <ol>
        <li>
          <p>
            By submitting this consent form, you may receive electronic
            Communications relating to your Navy Cash account. Communications
            include receipts, disclosures, notices, agreements, fee schedules,
            statements, records, documents or other information that we are
            required or that we desire to deliver to you. Examples may include,
            but are not limited to, the following:
          </p>
          <br />
          <ol>
            <li>
              <p>
                Receipts, account agreements, pre-acquisition disclosures, fee
                schedules, and other account disclosures.
              </p>
            </li>
            <li>
              <p>
                Payment disclosures, including single payment or recurring
                payment authorization, and, if applicable, payment program
                disclosures.
              </p>
            </li>
            <li>
              <p>Account and activity statements.</p>
            </li>
            <li>
              <p>Privacy notices.</p>
            </li>
            <li>
              <p>
                Disclosures and notices that may be required by various laws and
                regulations such as the Electronic Fund Transfer Act, the Gramm
                Leach Bliley Act, or other applicable federal or state laws and
                regulations.
              </p>
            </li>
            <li>
              <p>
                Other information related to your account, including account
                servicing letters, notices and forms.
              </p>
              <p><br /></p>
            </li>
          </ol>
        </li>
        <li>
          <p>
            The above shall collectively be referred to as “Communications” that
            we may send to you electronically. All Communications from us
            delivered to you in electronic format will be considered “in
            writing.” You should print or download, for your records, a copy of
            this document and any other Communications that are important to
            you. We may always, in our sole discretion or if required by law,
            provide you with any Communications in paper form, even if you have
            chosen to receive it electronically. Communications shall be sent to
            the primary address we show for you in our records.
          </p>
          <p><br /></p>
        </li>
        <li>
          <p>WITHDRAWAL OF THIS CONSENT</p>
          <p>
            You may withdraw this consent at any time after submission by
            emailing
            <a href="mailto:navycash@frb.org" class="a" target="_blank">
              navycash&#64;frb.org</a
            >, calling 866-362-8922 (voice), or visit
            <a href="http://www.navycash.com/" target="_blank"
              >www.navycash.com.</a
            >
          </p>
        </li>
        <li>
          <p>OBTAINING PAPER COPIES</p>
          <p>
            You may request a paper copy of a Communication that previously was
            provided or made available to you electronically by emailing
            <a href="mailto:navycash@frb.org" class="a" target="_blank">
              navycash&#64;frb.org</a
            >, calling 866-362-8922 (voice), or visit
            <a href="http://www.navycash.com/" target="_blank"
              >www.navycash.com.
            </a>
            We will not charge a fee for such paper copies.
          </p>
        </li>
        <li>
          <p>UPDATING ELECTRONIC INFORMATION</p>
          <p>
            It is your responsibility to provide us with a true, accurate and
            complete email address, contact information and any other
            information needed to contact you electronically. To update your
            electronic address, email
            <a href="mailto:navycash@frb.org" class="a" target="_blank"
              >navycash&#64;frb.org </a
            >, call 866-362-8922 (voice), or visit
            <a href="http://www.navycash.com/" class="a" target="_blank"
              >www.navycash.com </a
            ><span
              >. You agree to promptly notify us when you change your email or
              other electronic address. At our option, we may treat your
              provision of an invalid email address, or the subsequent
              malfunction of a previously valid email address, as a withdrawal
              of your consent to receive electronic Communications.</span
            >
          </p>
          <p><br /></p>
        </li>
        <li>
          <p>SYSTEM REQUIREMENTS</p>
          <br />
          <p>
            To receive the requested Communications electronically, you will
            need the following:
          </p>
          <br />
          <ol>
            <li>
              <p>
                An active email address and Internet connection, along with a
                web-enabled device with an operating system capable of
                supporting items 2 and 3.
              </p>
            </li>
            <li>
              <p>
                A current version of an Internet browser which is currently
                being supported by its publisher and which we support. Current
                versions of Internet browsers which we support include Microsoft
                Edge (Windows 10 only), Internet Explorer, Firefox, Safari or
                Chrome.
              </p>
            </li>
            <li>
              <p>
                Access to a printer or the ability to download information to
                keep copies for your records. You will also need a version of a
                program that accurately reads and displays PDF files. We
                currently support Adobe Acrobat Reader.
              </p>
            </li>
          </ol>
        </li>
      </ol>
    </li>
  </ol>
  <p><br /></p>
  <p>
    If we change hardware or software requirements, we will post the current
    hardware and software requirements within updated versions of this
    agreement, available via the Navy Cash website at
    <a href="http://www.navycash.com/" target="_blank">www.navycash.com.</a>
  </p>
  <br />
  <p>
    By providing your consent to this agreement, you give your affirmative
    consent to PNC to provide electronic Communications to you, as described
    above. You further affirm and confirm that you have the hardware and
    software described above, that you are able to receive and review electronic
    records, and that you have provided, or will provide to us, a current, valid
    email address to which we may deliver electronic Communications. By
    obtaining electronic delivery of Communications, you confirm that you are
    authorized to, and do, consent on behalf of all the other account owners,
    authorized signers, authorized representatives and/or delegates identified
    with your Navy Cash account.
  </p>
  <br />
  <p>
    Navy Cash is a Registered service mark of Bureau of the Fiscal Service, U.S.
    Department of the Treasury.
  </p>
  <p>
    ©2019 The PNC Financial Services Group, Inc. All rights reserved. PNC Bank,
    National Association. <b>Member FDIC </b>
    <span
      ><img width="91" height="17" alt="image" src="../assets/img/Image_002.jpg"
    /></span>
  </p>
</div>
